/**
 * Put-away async thunks (PutAwayV2)
 *
 * Endpoints:
 * - List candidates:   GET  /rest/s1/handheld/putAwayV2
 * - Resolve target:    GET  /rest/s1/handheld/putAwayV2/target
 * - Move (put away):   POST /rest/s1/handheld/putAwayV2/target
 * - Search locations:  GET  /rest/s1/handheld/facility/{facilityId}/locations
 * - Validate location: GET  /rest/s1/handheld/facility/{facilityId}/scanIdGeneral
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
var authHeaders = function () {
    var _a;
    return ({
        moquiSessionToken: (_a = localStorage.getItem('moquiSessionToken')) !== null && _a !== void 0 ? _a : ''
    });
};
var getFacilityId = function () { var _a; return (_a = localStorage.getItem('facilityId')) !== null && _a !== void 0 ? _a : ''; };
// const getActiveOrgId = () => localStorage.getItem('activeOrgId') ?? ''
// Suggestions are bulk-then-pick only, but a typed/scanned destination may be ANY
// location (including receiving) per requirements -- only cart/pack are rejected,
// matching the receiving flow's validation (they're workstations, not storage).
var DISALLOWED_DEST_TYPES = ['FltCart', 'FltPack'];
var getLocationTypeLabel = function (locationTypeEnumId) {
    if (!locationTypeEnumId)
        return '';
    try {
        var raw = localStorage.getItem('locationEnumsList');
        var list = raw ? JSON.parse(raw) : [];
        var matched = Array.isArray(list)
            ? list.find(function (entry) { return (entry === null || entry === void 0 ? void 0 : entry.enumId) === locationTypeEnumId; })
            : undefined;
        if (matched === null || matched === void 0 ? void 0 : matched.description)
            return matched.description;
    }
    catch (_a) {
        // fall through to the enumId-based fallback
    }
    return locationTypeEnumId.replace(/^Flt/, '');
};
// Fetch the put-away worklist.
export var fetchPutAwayCandidates = createAsyncThunk('putaway/fetchCandidates', function () { return __awaiter(void 0, void 0, void 0, function () {
    var facilityId, response;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                facilityId = getFacilityId();
                return [4 /*yield*/, axios.get("/rest/s1/handheld/putAwayV2", {
                        params: { facilityId: facilityId },
                        headers: authHeaders()
                    })];
            case 1:
                response = _b.sent();
                return [2 /*return*/, ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.putAwayList) || []];
        }
    });
}); });
// Resolve a scanned container/receiving tag into a move target. Resolves to a
// shaped result (never rejects) so the UI can show inline scan errors.
export var resolvePutAwayTarget = createAsyncThunk('putaway/resolveTarget', function (_a) {
    var scanId = _a.scanId;
    return __awaiter(void 0, void 0, void 0, function () {
        var facilityId, barcode, response, target, e_1;
        var _b, _c, _d, _e, _f, _g, _h;
        return __generator(this, function (_j) {
            switch (_j.label) {
                case 0:
                    facilityId = getFacilityId();
                    barcode = (scanId || '').trim();
                    _j.label = 1;
                case 1:
                    _j.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, axios.get("/rest/s1/handheld/putAwayV2/target", {
                            params: { facilityId: facilityId, scanId: barcode },
                            headers: authHeaders()
                        })];
                case 2:
                    response = _j.sent();
                    target = (_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.putAwayTarget;
                    if (!target)
                        return [2 /*return*/, { error: 'Nothing found for that scan' }];
                    return [2 /*return*/, { target: target }];
                case 3:
                    e_1 = _j.sent();
                    return [2 /*return*/, {
                            error: ((_d = (_c = e_1 === null || e_1 === void 0 ? void 0 : e_1.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.errors) ||
                                ((_h = (_g = (_f = (_e = e_1 === null || e_1 === void 0 ? void 0 : e_1.response) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.errorsList) === null || _g === void 0 ? void 0 : _g[0]) === null || _h === void 0 ? void 0 : _h.message) ||
                                'Could not find that container or tag'
                        }];
                case 4: return [2 /*return*/];
            }
        });
    });
});
// Free-type/scan search of storage locations (Bulk/Pick). Never receiving.
export var searchPutAwayLocations = createAsyncThunk('putaway/searchLocations', function (_a) {
    var term = _a.term, types = _a.types;
    return __awaiter(void 0, void 0, void 0, function () {
        var facilityId, response, list, _b;
        var _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    facilityId = getFacilityId();
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, axios.get("/rest/s1/handheld/facility/" + facilityId + "/locations", {
                            params: {
                                locationTypeEnumId: (types || ['FltBulk', 'FltPick']).join(','),
                                term: (term === null || term === void 0 ? void 0 : term.trim()) || undefined,
                                limit: 50
                            },
                            headers: authHeaders()
                        })];
                case 2:
                    response = _d.sent();
                    list = ((_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.locations) || [];
                    return [2 /*return*/, list
                            .filter(function (loc) { return loc === null || loc === void 0 ? void 0 : loc.locationSeqId; })
                            .map(function (loc) {
                            var typeLabel = getLocationTypeLabel(loc.locationTypeEnumId);
                            return {
                                key: loc.locationSeqId,
                                value: typeLabel ? loc.locationSeqId + " - " + typeLabel : loc.locationSeqId,
                                locationTypeEnumId: loc.locationTypeEnumId
                            };
                        })];
                case 3:
                    _b = _d.sent();
                    return [2 /*return*/, []];
                case 4: return [2 /*return*/];
            }
        });
    });
});
// Resolve a typed/scanned location to its canonical seqId; any location is accepted
// except cart/pack.
export var validatePutAwayLocation = createAsyncThunk('putaway/validateLocation', function (_a) {
    var rawLocation = _a.rawLocation;
    return __awaiter(void 0, void 0, void 0, function () {
        var scanId, facilityId, response, data, locationSeqId, locationTypeEnumId, _b;
        var _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    scanId = (rawLocation || '').trim();
                    facilityId = getFacilityId();
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, axios.get("/rest/s1/handheld/facility/" + facilityId + "/scanIdGeneral?scanId=" + encodeURIComponent(scanId), { headers: authHeaders() })];
                case 2:
                    response = _d.sent();
                    data = response === null || response === void 0 ? void 0 : response.data;
                    locationSeqId = data === null || data === void 0 ? void 0 : data.locationSeqId;
                    locationTypeEnumId = (_c = data === null || data === void 0 ? void 0 : data.facilityLocation) === null || _c === void 0 ? void 0 : _c.locationTypeEnumId;
                    if ((data === null || data === void 0 ? void 0 : data.messages) || !locationSeqId) {
                        return [2 /*return*/, { ok: false, error: 'Incorrect location, scan again' }];
                    }
                    if (DISALLOWED_DEST_TYPES.includes(locationTypeEnumId)) {
                        return [2 /*return*/, { ok: false, error: 'Incorrect location, scan again' }];
                    }
                    return [2 /*return*/, {
                            ok: true,
                            locationSeqId: locationSeqId,
                            locationType: getLocationTypeLabel(locationTypeEnumId)
                        }];
                case 3:
                    _b = _d.sent();
                    return [2 /*return*/, { ok: false, error: 'Failed to validate location. Try again.' }];
                case 4: return [2 /*return*/];
            }
        });
    });
});
// Move a container/asset to its destination location. Resolves to a shaped
// result (never rejects) so the UI can show the server message either way.
export var movePutAway = createAsyncThunk('putaway/move', function (args) { return __awaiter(void 0, void 0, void 0, function () {
    var facilityId, body, response, e_2;
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                facilityId = getFacilityId();
                body = { toLocationSeqId: args.toLocationSeqId, facilityId: facilityId };
                if (args.containerId)
                    body.containerId = args.containerId;
                if (args.assetId)
                    body.assetId = args.assetId;
                if (args.quantity != null)
                    body.quantity = args.quantity;
                _k.label = 1;
            case 1:
                _k.trys.push([1, 3, , 4]);
                return [4 /*yield*/, axios.post("/rest/s1/handheld/putAwayV2/target", body, {
                        headers: authHeaders()
                    })];
            case 2:
                response = _k.sent();
                if ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.result) {
                    return [2 /*return*/, { ok: true, message: (_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.message }];
                }
                return [2 /*return*/, { ok: false, error: ((_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.message) || 'Move failed' }];
            case 3:
                e_2 = _k.sent();
                return [2 /*return*/, {
                        ok: false,
                        error: ((_e = (_d = e_2 === null || e_2 === void 0 ? void 0 : e_2.response) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.errors) ||
                            ((_j = (_h = (_g = (_f = e_2 === null || e_2 === void 0 ? void 0 : e_2.response) === null || _f === void 0 ? void 0 : _f.data) === null || _g === void 0 ? void 0 : _g.errorsList) === null || _h === void 0 ? void 0 : _h[0]) === null || _j === void 0 ? void 0 : _j.message) ||
                            'Move failed'
                    }];
            case 4: return [2 /*return*/];
        }
    });
}); });
